import React, { useEffect, useState } from "react";
import {
  getCourseLessonGradeYearReports,
  saveOverviewTexts,
  getOverviewTexts,
} from "../../../lib/studentcourselessonreport";
import style from "./globalstudentcourselessonreport.module.css";
import { Toast, ToastContainer } from "react-bootstrap";
import { getColorClass,getHeaderClass } from "./globalstudentgparigorsummary";

const OVERVIEW_KEY = "gradeYear";

export default function GlobalStudentCourseLessonGradeYearReport({
  studentId,
  isStudent = false,
}) {
  const [data, setData] = useState([]);
  const [levels, setLevels] = useState([]);
  const [overview, setOverview] = useState({});
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const levelClassMap = {
    AP: style.apCell,
    CC: style.ccCell,
    HR: style.hrCell,
    EA: style.eaCell,
    RG: style.rgCell,
    OT: style.otCell,
  };

  useEffect(() => {
    loadData();
  }, [studentId]);

  const loadData = async () => {
    const res = await getCourseLessonGradeYearReports(studentId);
    const sorted = [...res].sort((a, b) => a.courseyear - b.courseyear);
    setData(sorted);

    // Dinamik seviyeleri belirle (Total, studentId hariç)
    const dynamicLevels = new Set();
    sorted.forEach((row) => {
      Object.keys(row).forEach((key) => {
        if (!["courseyear", "studentId", "Total"].includes(key)) {
          dynamicLevels.add(key);
        }
      });
    });
    
      const customOrder = ["AP", "CC", "HR", "EA", "RG", "OT"];
  const sortedLevels = customOrder.filter(lvl => dynamicLevels.has(lvl));
   setLevels(sortedLevels);

    const overviewRes = await getOverviewTexts(studentId);
    const overviewMap = {};
    overviewRes.forEach((item) => {
      overviewMap[item.type] = item.desc;
    });
    setOverview(overviewMap);
  };

  const handleOverviewChange = (value) => {
    setOverview((prev) => ({ ...prev, [OVERVIEW_KEY]: value }));
  };

  const handleUpdate = async () => {
    await saveOverviewTexts(studentId, {
      [OVERVIEW_KEY]: overview[OVERVIEW_KEY] || "",
    });
    setToastMessage("Update successful!");
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
    loadData();
  };

  const getLevelTotal = (level) =>
    data.reduce((sum, row) => sum + (row[level] ?? 0), 0).toFixed(1);

  const getRowTotal = (row) =>
    levels.reduce((sum, lvl) => sum + (row[lvl] ?? 0), 0).toFixed(1);

  return (
    <div className="card p-3">
      <h4 className="mb-3">Number of Credits</h4>

      <ToastContainer style={{ top: "1rem", right: "1rem", position: "fixed" }}>
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      {/*}<h5 className="mb-3">Number of Credits</h5> {*/}

      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th style={{ width: "150px" }}>Grade</th>
            <th>Total</th>
            {levels.map((lvl) => (
               <th key={lvl} className={getHeaderClass(lvl)}>{lvl}</th>
            ))}
            <th style={{ width: "400px" }}>Overview</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={row.courseyear}>
              <td>{`Grade-${row.courseyear}`}</td>
              <td className={style.totalCell}>{getRowTotal(row)}</td>
              {levels.map((lvl) => (
                <td key={lvl} className={row[lvl] > 0 ? getHeaderClass(lvl): ""}>
                  {(row[lvl] ?? 0).toFixed(1)}
                </td>
              ))}
              {index === 0 && (
                <td rowSpan={data.length + 1} className={style.overviewCell}>
                  {!isStudent ? (
                    <textarea
                      rows={data.length * 2}
                      className="form-control flex-grow-1"
                      style={{ resize: "none" }}
                      value={overview[OVERVIEW_KEY] || ""}
                      onChange={(e) => handleOverviewChange(e.target.value)}
                    />
                  ) : (
                    <div className="bg-light border rounded p-2 flex-grow-1 overflow-auto">
                      {overview[OVERVIEW_KEY]}
                    </div>
                  )}
                </td>
              )}
            </tr>
          ))}

          <tr>
            <td>
              <strong>TOTAL</strong>
            </td>
            <td className={style.totalCell}>
              {data
                .reduce((sum, row) => sum + parseFloat(getRowTotal(row)), 0)
                .toFixed(1)}
            </td>
            {levels.map((lvl) => (
              <td key={lvl} className={(getLevelTotal(lvl) > 0 ? getHeaderClass(lvl): "" ) + " fw-bold"}>
                {getLevelTotal(lvl)}
              </td>
            ))}
          </tr>
        </tbody>
      </table>

      {!isStudent && (
        <div className="text-end">
          <button className="btn btn-primary" onClick={handleUpdate}>
            Update
          </button>
        </div>
      )}
    </div>
  );
}
